import React, { useState, useEffect } from "react";
import { useSearchParams } from 'react-router-dom';
import Datapoint from "../datapoint/datapointV2";
import { syncOneDatapoint} from "../../indexDB/utils/datapoint"
import LoadingSpinner from './LoadingSpinner';
import ConfirmationComponent from "./ConfirmationComponent";

export default function Sync ({handleLogout, dataPointID}){
    const [searchParams, setSearchParams] = useSearchParams();
    const [dataset,setDataset] = useState(null);
    const [isSyncing, setisSyncing] = useState(true);

    useEffect(() => {
        const syncRecord = async () => {
            console.log(dataPointID)
            const status = await syncOneDatapoint(dataPointID,handleLogout)
            setisSyncing(false)
        }
        syncRecord()

      }, []);

    return (
        <>
        {isSyncing ? <LoadingSpinner message="Submitting Your Form. Please do not close this tab"/> : <ConfirmationComponent message="Thanks, your form is submitted. You can close the page now."/>}
        </>

    );
} 